import { getLocal, saveLocal } from '/@/utils/'
import { defineStore } from 'pinia'

// 定义state的接口 (如果您的项目使用TypeScript)
interface SystemConfigState {
  appFontSize: number;
  // 其他系统配置相关的state...
  menuButtonInfo: any | null; // 新增胶囊信息字段
  isDarkMode: boolean; // 深色模式状态
}

export const useSystemConfigStore = defineStore('system-config', {
  state: () => ({
    // 从本地存储读取字体大小，如果不存在则默认为14
    appFontSize: uni.getStorageSync('fontSize') || 14,
    systemConfig: getLocal('systemConfig'),
    menuButtonInfo: null, // 新增字段
    isDarkMode: uni.getStorageSync('isDarkMode') || false, // 从本地存储读取深色模式状态
  }),
  getters: {},
  actions: {
    setSystemConfig(systemConfig: any) {
      this.systemConfig = systemConfig
      saveLocal('systemConfig', systemConfig)
    },
    // 设置字体大小并保存到本地存储
    setAppFontSize(fontSize: number) {
      this.appFontSize = fontSize;
      uni.setStorageSync('fontSize', fontSize);
    },
    // 新增设置胶囊信息方法
    setMenuButtonInfo(info: any) {
      this.menuButtonInfo = info;
    },
    // 从本地存储加载字体大小 (主要用于应用启动时)
    loadAppFontSize() {
      const savedFontSize = uni.getStorageSync('fontSize') || 14;
      this.appFontSize = savedFontSize;
    },
    // 设置深色模式状态
    setIsDarkMode(isDark: boolean) {
      this.isDarkMode = isDark;
      uni.setStorageSync('isDarkMode', isDark);
    },
    // 切换深色模式
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      uni.setStorageSync('isDarkMode', this.isDarkMode);
    }
  },
})
